import {Subscription} from 'rxjs';
import {distinctUntilChanged, filter} from 'rxjs/operators';
import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Store} from '@ngxs/store';
import {DashboardStudyViewerControlsComponent} from '../dashboard-study-viewer-controls/dashboard-study-viewer-controls.component';
import {DashboardStudyViewerControllerService} from '../../services/dashboard-study-viewer-controller/dashboard-study-viewer-controller.service';
import {DashboardStudy, DashboardUser} from '../../../dashboard-new/types/dashboard.types';
import {DashboardStudyPapayaComponent} from '../../../dashboard-study-papaya/components/dashboard-study-papaya/dashboard-study-papaya.component';
import {DashboardViewRegionsState} from '../../../dashboard-view-regions/states/dashboard-view-regions/dashboard-view-regions.state';
import {DashboardViewRegion} from '../../../dashboard-view-regions/types/dashboard-view-regions.types';

@Component({
  selector: 'app-dashboard-study-viewer',
  templateUrl: './dashboard-study-viewer.component.html',
  styleUrls: ['./dashboard-study-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DashboardStudyPapayaComponent, DashboardStudyViewerControlsComponent],
})
export class DashboardStudyViewerComponent implements OnInit, OnDestroy {
  @ViewChild('studyViewerPapaya') studyViewerPapaya: HTMLDivElement;

  public readonly selectedViewRegion$ = this.store.select(DashboardViewRegionsState.selectedViewRegion);

  @Input({required: true}) public dashboardUser: DashboardUser;
  @Input({required: true}) public dashboardStudy: DashboardStudy;

  public readonly isPapayaRendered = this.studyViewerControllerService.isPapayaRendered;

  private readonly subscription = new Subscription();

  constructor(private store: Store, private studyViewerControllerService: DashboardStudyViewerControllerService) {}

  ngOnInit(): void {
    // Todo: handle study id change.

    this.subscription.add(
      this.selectedViewRegion$
        .pipe(
          filter(viewRegion => !!viewRegion),

          distinctUntilChanged((prevViewRegion, currViewRegion) => prevViewRegion.id === currViewRegion.id)
        )
        .subscribe(viewRegion => {
          this.focusViewRegion(viewRegion);
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public focusViewRegion(viewRegion: DashboardViewRegion): void {
    this.studyViewerControllerService.focusViewRegion(viewRegion);
  }
}
